import Form from "../../components/form/form";
import Joi from "joi-browser";
import React, {  Fragment } from "react";
import "./sizing.css";
import { Link } from "react-router-dom";

export default class DryerAbsorptionHitterlessSizing extends Form {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            suggestedModel: "",
            suggestedModelId: ""
        };
    }
    state = {
        data: {
            InletFlowRate: "",
            InletPressure: "",
            InletTemperature: ""
        },
        errors: {},
    };

    schema = {
        InletFlowRate: Joi.number().min(0).error(new Error("نرخ جریان ورودی از نوع عدد و اجباری است")),
        InletPressure: Joi.number().required().error(new Error("فشار ورودی یک عدد و اجباری است")),
        InletTemperature: Joi.number().required().error(new Error("دمای ورودی یک عدد و اجباری است")),
    };

    onChange = async (value) => {
        this.setState({ captchaRef: value });
    }

    doSubmit = async () => {
        const { data } = this.state;
        try {
            let step1 = 0.67926301 * Math.log(data.InletPressure) - 0.32132185;
            let step2 = -0.000000242424 * (data.InletTemperature ** 4) + 0.000034343434 * (data.InletTemperature ** 3) - 0.001878787879 * (data.InletTemperature ** 2) + 0.033864357865 * data.InletTemperature + 1.005411255408;
            let step3 = (data.InletFlowRate / (step1 * step2))
            var ModelName = "";
            var ModelId = "";
            if (step3 < 19.2) {
                ModelName = "HDT 3";
                ModelId = "99";
            }
            else if (step3 > 19.2 && step3 < 31.8) {
                ModelName = "HDT 5";
                ModelId = "100";
            }
            else if (step3 > 31.8 && step3 < 45.6) {
                ModelName = "HDT 8";
                ModelId = "101";
            }
            else if (step3 > 45.6 && step3 < 72) {
                ModelName = "HDT 12";
                ModelId = "102";
            }
            else if (step3 > 72 && step3 < 111) {
                ModelName = "HDT 18";
                ModelId = "103";
            }
            else if (step3 > 111 && step3 < 150) {
                ModelName = "HDT 25";
                ModelId = "104";
            }
            else if (step3 > 150 && step3 < 180) {
                ModelName = "HDT 30";
                ModelId = "105";
            }
            else if (step3 > 180 && step3 < 234) {
                ModelName = "HDT 40";
                ModelId = "106";
            }
            else if (step3 > 234 && step3 < 300) {
                ModelName = "HDT 50";
                ModelId = "107";
            }
            else if (step3 > 300 && step3 < 372) {
                ModelName = "HDT 60";
                ModelId = "108";
            }
            else if (step3 > 372 && step3 < 450) {
                ModelName = "HDT 75";
                ModelId = "109";
            }
            else if (step3 > 450 && step3 < 540) {
                ModelName = "HDT 90";
                ModelId = "110";
            }
            else if (step3 > 540 && step3 < 768) {
                ModelName = "HDT 130";
                ModelId = "111";
            }
            else if (step3 > 768 && step3 < 927) {
                ModelName = "HDT 160";
                ModelId = "112";
            }
            else if (step3 > 927 && step3 < 1230) {
                ModelName = "HDT 200";
                ModelId = "113";
            }
            else if (step3 > 1230 && step3 < 1530) {
                ModelName = "HDT 250";
                ModelId = "114";
            }
            else if (step3 > 1530 && step3 < 1800) {
                ModelName = "HDT 300";
                ModelId = "115";
            }
            else if (step3 > 1800 && step3 < 2160) {
                ModelName = "HDT 350";
                ModelId = "116";
            }
            else if (step3 > 2160 && step3 < 2560) {
                ModelName = "HDT 400";
                ModelId = "117";
            }
            else if (step3 > 2560 && step3 < 2736) {
                ModelName = "HDT 450";
                ModelId = "118";
            }
            else if (step3 > 2736 && step3 < 3750) {
                ModelName = "HDT 620";
                ModelId = "119";
            }
            else if (step3 > 3750 && step3 < 4860) {
                ModelName = "HDT 800";
                ModelId = "120";
            }
            else if (step3 > 4860 && step3 < 6120) {
                ModelName = "HDT 1000";
                ModelId = "121";
            }
            else if (step3 > 6120 && step3 < 7560) {
                ModelName = "HDT 1200";
                ModelId = "122";
            }
            else if (step3 > 7560 && step3 < 9060) {
                ModelName = "HDT 1500";
                ModelId = "123";
            }
            else if (step3 > 9060) {
                ModelName = "Special Design";
            }
            this.setState({ suggestedModel: ModelName });
            this.setState({ suggestedModelId: ModelId });
        } catch (ex) {
        }
    };

    render() {
        return (
            <section>
                <div className="row">
                    <form onSubmit={this.handleSubmit} action="/">
                        <div className="mb-4 mt-3">
                            {this.renderInput(
                                "InletFlowRate",
                                "",
                                "نرخ جریان ورودی",
                                "text",
                                "form-control form-control-lg",
                                "true"
                            )}
                        </div>
                        <h6>نرخ جریان ورودی بر حسب نرمال متر مکعب Nm³/h</h6>
                        <div className="mb-4 mt-3">
                            {this.renderInput(
                                "InletPressure",
                                "",
                                "فشار ورودی",
                                "text",
                                "form-control form-control-lg",
                                "true"
                            )}
                        </div>
                        <h6>فشار ورودی بر حسب بار گیج bar-g</h6>
                        <div className="mb-4 mt-3">
                            {this.renderInput(
                                "InletTemperature",
                                "",
                                "دمای ورودی",
                                "text",
                                "form-control form-control-lg",
                                "true"
                            )}
                        </div>
                        <h6>دمای ورودی بر حسب درجه سانتیگراد °C</h6>
                        <div className="d-grid mb-4">
                            {this.renderButton("یافتن مدل مناسب")}
                        </div>
                        {this.state.suggestedModel !== "" &&
                            <Fragment>
                                <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                                <div className="modelheadbox">
                                    <h1 >{this.state.suggestedModel}</h1>
                                    <hr className="divider" />
                                </div>
                                <div className="row hrow mt-4">
                                    <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                                </div>
                            </Fragment>
                        }
                    </form>
                </div>
            </section>

        );
    }
}